import { RouterProvider } from 'react-router-dom';
import './App.css';

import { router } from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <AuthProvider>
      <CookieConsentProvider>
        <RouterProvider router={router} />
        <ToastContainer position="top-right" autoClose={3000} />
      </CookieConsentProvider>
    </AuthProvider>
  );
}

export default App;
